import React from "react";
import { GiCheckMark } from "react-icons/gi";

const TentangKami: React.FC = () => {
  const IconVerif = GiCheckMark as React.FC<React.SVGProps<SVGSVGElement>>;
  return (
    <section className=" pt-10 pb-20 max-sm:px-6 px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* ================= TENTANG KAMI ================= */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center mb-12 justify-center">
          {/* Konten */}
          <div>
            <div className="max-sm:mb-2 mb-6 ">
              <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 max-sm:text-center">
                Tentang <span className="font-bilbo text-red-500">Kami</span>{" "}
              </h1>
              <div className="border-b-2 border-red-500 w-[50%] hidden md:block"></div>
            </div>

            <h2 className="text-lg md:text-2xl font-bold text-gray-800 mb-4 font-bilbo max-sm:text-center">Ekosistem Digital untuk Kolaborasi Sosial</h2>

            <p className="text-gray-600 text-base md:text-lg leading-relaxed text-justify">
              Kami adalah pusat gravitasi kolaborasi sosial di Indonesia. Sebagai <span className="font-semibold text-gray-800">Ekosistem Digital Terintegrasi</span> dan di bawah inisiasi Kementerian Koordinator Bidang Pemberdayaan
              Masyarakat, misi kami sederhana: memastikan tidak ada wilayah yang terabaikan.
            </p>

            <p className="text-gray-600 text-base md:text-lg  leading-relaxed mt-5 text-justify">
              Dengan menyatukan data dan sumber daya dalam satu platform, kami mengubah fragmentasi menjadi aksi nyata yang terarah untuk masyarakat Indonesia yang lebih mandiri.
            </p>

            {/* Point tambahan */}
            <div className="mt-6 space-y-3 text-base md:text-base">
              <div className="flex items-start gap-3">
                <IconVerif className="text-red-600 mt-1 text-2xl" />
                <div className="text-gray-700 w-full">
                  <strong>Kolaborasi Terpadu</strong> – Menyatukan pemerintah, NGO, dan sektor swasta dalam satu ekosistem digital yang saling terhubung.
                </div>
              </div>
              <div className="flex items-start gap-3">
                <IconVerif className="text-red-600 mt-1 text-2xl" />
                <div className="text-gray-700 w-full">
                  <strong>Aksi Berbasis Data</strong> – Menghadirkan keputusan dan program sosial yang tepat sasaran melalui data terintegrasi dan terverifikasi.
                </div>
              </div>
            </div>
          </div>

          {/* Gambar */}
          <div className="relative">
            <img src="/images/tentangkami.png" alt="Tentang Kami" className=" w-full object-cover" />
          </div>
        </div>

        {/* ================= VISI & MISI ================= */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 justify-center">
          {/* VISI */}
          <div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-red-600 mb-6">VISI</h2>
            <p className="text-base md:text-lg text-gray-700 mb-6">Terwujudnya Ekosistem Pemberdayaan Masyarakat yang Mandiri.</p>

            <div className="hidden md:block">
              <div className="flex justify-center">
                <img src="/images/memberi.png" alt="" className="w-[70%] h-96" />
              </div>
            </div>
            {/* 
            <div className="space-y-4">
              <div className="flex gap-3">
                <IconVerif className="text-black mt-1 text-2xl" />
                <div className="text-gray-700 w-full">
                  <strong>Integrasi Nasional:</strong> Menjadi satu-satunya wadah yang menyatukan data dan gerak seluruh stakeholder pemberdayaan (Pemerintah, NGO, dan Swasta) di Indonesia.
                </div>
              </div>
              <div className="flex gap-3 w-full">
                <IconVerif className="text-black mt-1 text-2xl" />
                <div className="text-gray-700 w-full">
                  <strong>Kemandirian Ekonomi:</strong> Mengubah paradigma masyarakat dari penerima bantuan menjadi pelaku ekonomi yang produktif.
                </div>
              </div>
              <div className="flex gap-3">
                <IconVerif className="text-black mt-1 text-2xl" />
                <div className="text-gray-700 w-full">
                  <strong>Transparansi Mutlak:</strong> Sistem terbuka, jujur, dan terukur untuk membangun kepercayaan publik.
                </div>
              </div>
            </div> */}
          </div>

          {/* MISI */}
          <div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6">MISI</h2>
            <p className="text-base md:text-lg text-gray-700 mb-6">Menggerakkan Kolaborasi Nyata melalui Inovasi Teknologi.</p>

            <div className="space-y-4 text-base md:text-base">
              <div className="flex gap-3">
                <IconVerif className="text-red-600 mt-1 text-2xl" />
                <div className="text-gray-700 w-full">
                  <strong>Digitalisasi Basis Data Sosial:</strong> Membangun Single Source of Truth untuk pemetaan kebutuhan nasional.
                </div>
              </div>
              <div className="flex gap-3">
                <IconVerif className="text-red-600 mt-1 text-2xl" />
                <div className="text-gray-700 w-full">
                  <strong>Transformasi Kapasitas Masyarakat:</strong> Edukasi dan sertifikasi digital bagi NGO dan UMKM.
                </div>
              </div>
              <div className="flex gap-3">
                <IconVerif className="text-red-600 mt-1 text-2xl" />
                <div className="text-gray-700 w-full">
                  <strong>Orkestrasi Sumber Daya Strategis:</strong> Sinkronisasi CSR dan bantuan pemerintah agar tepat sasaran dan berkelanjutan.
                </div>
              </div>

              <div className="flex gap-3">
                <IconVerif className="text-red-600 mt-1 text-2xl" />
                <div className="text-gray-700 w-full">
                  <strong>Integrasi Nasional:</strong> Menjadi satu-satunya wadah yang menyatukan data dan gerak seluruh stakeholder pemberdayaan (Pemerintah, NGO, dan Swasta) di Indonesia.
                </div>
              </div>
              <div className="flex gap-3 w-full">
                <IconVerif className="text-red-600 mt-1 text-2xl" />
                <div className="text-gray-700 w-full">
                  <strong>Kemandirian Ekonomi:</strong> Mengubah paradigma masyarakat dari penerima bantuan menjadi pelaku ekonomi yang produktif.
                </div>
              </div>
              <div className="flex gap-3">
                <IconVerif className="text-red-600 mt-1 text-2xl" />
                <div className="text-gray-700 w-full">
                  <strong>Transparansi Mutlak:</strong> Sistem terbuka, jujur, dan terukur untuk membangun kepercayaan publik.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TentangKami;
